"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PixiGameComponent = void 0;
var _core = require("@dragon/core");
var _pixi = require("pixi.js");
var _LayoutManager = _interopRequireDefault(require("./Layout/LayoutManager"));
var _pixiAppSingleton = _interopRequireDefault(require("./pixiAppSingleton"));
var _CellAnchorLocation = require("./CellAnchorLocation");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, e, r, o) { var p = _get(_getPrototypeOf(1 & o ? t.prototype : t), e, r); return 2 & o ? function (t) { return p.apply(r, t); } : p; }
function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var PixiGameComponent = exports.PixiGameComponent = /*#__PURE__*/function (_Container) {
  /**
   * Constructor for the PixiGameComponent
   * 
   * @param name Component name. needs to be unique, used in the component registry, leave this null if you do NOT wish this component to be part of the registry.
   */
  function PixiGameComponent(name, position) {
    var _this;
    _classCallCheck(this, PixiGameComponent);
    _this = _callSuper(this, PixiGameComponent);

    // if no name provided, dont register.
    _defineProperty(_this, "_anchorX", 0);
    _defineProperty(_this, "_anchorY", 0);
    /**
     * Calculated or fixed set width not taking scale or spill over animations into account
     * 
     * if this is set on a component it will be used to calculate fit to widths instead of the width. useful when the component width might vary.
     */
    _defineProperty(_this, "trueWidth", void 0);
    /**
     *  Calculated or fixed set height not taking scale or spill over animations into account
     */
    _defineProperty(_this, "trueHeight", void 0);
    /**
    * Where component should be placed.
    */
    _defineProperty(_this, "_position", void 0);
    /**
     * Singleton instance of the Pixi application.
     * used this to access pixi renderer etc. This provides access to the application in side each component.
     * Renderer can also be accessed through this.
     */
    _defineProperty(_this, "application", void 0);
    _defineProperty(_this, "name", void 0);
    /**
     * Translates pivot to work the same way as anchor does for sprites.
     * @param x 
     * @param y 
     */
    _defineProperty(_this, "setAnchor", function (x, y) {
      _this.anchorX = x;
      _this.anchorY = y != undefined ? y : x;
    });
    if (name) {
      _this.name = name;
      //Register in component registry.
      _core.gameComponentRegistry.register(_this);
    }

    // access singleton,
    _this.application = _pixiAppSingleton["default"].application;
    _this._position = position;
    //     console.log('***PixiGameComponent Name: ' + this.name)
    //     console.log(this._position)
    return _this;
  }
  _inherits(PixiGameComponent, _Container);
  return _createClass(PixiGameComponent, [{
    key: "_extractBreakPoint",
    value: function _extractBreakPoint(data, s) {
      // if its not an array, we assume there exist only one set of position data ( a single default)
      if (!Array.isArray(data)) return data;
      if (data.length < 1) throw Error("Empty PositionData Array");
      if (data.length == 1) return data[0];
      var dataToUse;
      for (var index = 0; index < data.length; index++) {
        var item = data[index];
        if (item.maxHeight && item.maxHeight > s.height) {
          return item;
        } else if (item.maxRatio && item.maxRatio > s.ratio) {
          return item;
        } else if (item.maxHeight == undefined) {
          dataToUse = item;
        }
      }
      return dataToUse;
    }

    // default game component position, built to be called by the layout manager to automate resize handling
  }, {
    key: "onResize",
    value: function onResize(s) {
      // if no position set we assume its not handled by this.
      if (!this._position) return;

      // reset scale, not doing this can affect below calculations.
      this.scale.set(1);
      var posData;

      // read the posData for the correct channel and orientation of the device.
      switch (s.channel) {
        case _core.Channel.Desktop:
          posData = this._extractBreakPoint(this._position.desktop, s);
          break;
        case _core.Channel.Mobile:
          if (!this._position.mobile) {
            console.warn(this.name + ' has not position data for mobile');
            return;
          }
          switch (s.orientation) {
            case _core.Orientation.Landscape:
              if (!this._position.mobile.landscape) {
                console.warn(this.name + ' has not position data for mobile landscape');
                return;
              }
              posData = this._extractBreakPoint(this._position.mobile.landscape, s);
              break;
            case _core.Orientation.Portrait:
              if (!this._position.mobile.portrait) {
                console.warn(this.name + ' has not position data for mobile portrait');
                return;
              }
              posData = this._extractBreakPoint(this._position.mobile.portrait, s);
              break;
          }
          break;
      }

      // this hides when hidden and shows when not hidden, important it goes both ways
      // if this attribute is NOT set its important we dont touch visible since it can overwrite other setting it. so if its hidden in once layout, make sure its true in the one it should be shown
      if (posData.hidden !== undefined) this.visible = !posData.hidden;

      // we get the cell we are to attach to. and we read the position for the correct anchor point on the cell.
      // default this is center.
      var cell = _LayoutManager["default"].getCell(posData.x, posData.y);
      var pos;
      switch (posData.cellAnchor) {
        case _CellAnchorLocation.CellAnchorLocation.TopCenter:
          pos = cell.getTopCenterPos();
          break;
        case _CellAnchorLocation.CellAnchorLocation.TopLeftCorner:
          pos = cell.getTopLeft();
          break;
        case _CellAnchorLocation.CellAnchorLocation.TopRightCorner:
          pos = cell.getTopRight();
          break;
        default:
          pos = cell.getCenterPos();
      }
      this.position.set(pos.x, pos.y);

      // if component should be full width.
      // use full for portrait mode reels etc.
      // this needs to be done before adjustments.
      if (posData.fillWidth) {
        var _this$trueWidth2;
        // console.log(this.name + ' width: ' + this.width)
        if (posData.fillWidthSpacing) {
          var _this$trueWidth;
          this.scale.set(s.width / ((_this$trueWidth = this.trueWidth) !== null && _this$trueWidth !== void 0 ? _this$trueWidth : this.width) * posData.fillWidthSpacing);
        } else this.scale.set(s.width / ((_this$trueWidth2 = this.trueWidth) !== null && _this$trueWidth2 !== void 0 ? _this$trueWidth2 : this.width));
      } else if (posData.scaleMultiplier) {
        this.scale.set(s.scaleFactorHd * posData.scaleMultiplier);
      } else {
        this.scale.set(s.scaleFactorHd);
      }

      // last we do adjustments.
      if (posData.offsetX != undefined && posData.offsetX != null) this.x += posData.offsetX * this.scale.x;
      if (posData.offsetY != undefined && posData.offsetY != null) this.y += posData.offsetY * this.scale.y;
    }

    /**
     * Important that you call SUPER if you override this!,
     * to ensure removal from the registry
     * @param options 
     */
  }, {
    key: "destroy",
    value: function destroy(options) {
      //console.log('Destroy ' + this.name)

      // we dont unregister when there is no name, if no name we assume its a no name component.
      if (this.name) {
        _core.gameComponentRegistry.unregister(this);
      }
      _superPropGet(PixiGameComponent, "destroy", this, 3)([options]);
    }
  }, {
    key: "anchorX",
    get: function get() {
      return this._anchorX;
    },
    set: function set(value) {
      var _this$trueWidth3;
      this._anchorX = value;
      this.pivot.x = value * ((_this$trueWidth3 = this.trueWidth) !== null && _this$trueWidth3 !== void 0 ? _this$trueWidth3 : this.width) / this.scale.x;
    }
  }, {
    key: "anchorY",
    get: function get() {
      return this._anchorY;
    },
    set: function set(value) {
      var _this$trueHeight;
      this._anchorY = value;
      this.pivot.y = value * ((_this$trueHeight = this.trueHeight) !== null && _this$trueHeight !== void 0 ? _this$trueHeight : this.height) / this.scale.y;
    }
  }]);
}(_pixi.Container);
//# sourceMappingURL=PixiGameComponent.js.map